module.exports = __webpack_public_path__ + "images/banner4.fb87.png";